import { ProductError, ProductErrorType } from '../../models';
import { LearnizMedia } from '../media';

export class MediaPlayerData {
  title?: string;
  description?: string;
  poster?: string;
  validator: MediaPlayerValidatorType;
  transcription?: string;
  time?: number; //if negative number I subtract the number to the total media length
  duration?: number;

  constructor(mediaPlayerData?: MediaPlayerData) {
    if (mediaPlayerData) {
      this.title = mediaPlayerData.title;
      this.description = mediaPlayerData.description;
      this.poster = mediaPlayerData.poster;
      this.validator = mediaPlayerData.validator;
      this.transcription = mediaPlayerData.transcription;
      this.time = mediaPlayerData.time;
      this.duration = mediaPlayerData.duration;
    } else {
      this.title = null;
      this.description = null;
      this.poster = null;
      this.validator = MediaPlayerValidatorType.START;
      this.transcription = null;
      this.time = null;
      this.duration = 0;
    }
  }
  static validate(data: MediaPlayerData, medias: LearnizMedia<any>[], payloadData: any): ProductError[] {
    // for now data doesn't need validation all properties are optional
    if (!medias || !medias.length) {
      return [{ type: ProductErrorType.MISSING, property: 'medias', payload: { ...payloadData } }];
    } else if (medias.length > 1) {
      return [{ type: ProductErrorType.TOO_MUCH_VALUES, property: 'medias', payload: { ...payloadData } }];
    }
    return LearnizMedia.validate(medias[0], payloadData);
  }
}

export enum MediaPlayerValidatorType {
  START = 'start',
  AT = 'at',
  ALL = 'all',
}

export class MediaPlayerParams {
  controlEnabled: boolean;
  validator?: MediaPlayerValidatorType;
  time?: number;
  duration?: number;

  constructor(params?: MediaPlayerParams) {
    this.controlEnabled = params?.controlEnabled ?? true;
    this.validator = params?.validator ?? MediaPlayerValidatorType.ALL;
    this.time = params?.time ?? 0;
    this.duration = params?.time ?? 0;
  }
}
